import * as React from 'react';
import { memo } from "react";
import type { PageData } from "../../js/data/pageData.ts";
import { AssetMode } from "../../js/enums.ts";
import { getImgUrl } from "../../js/mediaLibrary/assetUtils.ts";
import { format } from "date-fns";
import IconFontAwesome from "../../js/components/iconFontAwesome.tsx";

type Props = React.ComponentPropsWithoutRef<"div"> & {
	news: PageData
}

function NewsBox({news, ...otherProps}: Props) {
	return (<>
			<div className="w-full md:w-1/2 lg:w-1/3 px-4 xl:px-8 mb-12">
				<div className="flex flex-col h-full overflow-hidden">
					<div className="flex flex-col h-full">
						{/*<p className="text-base">{format(news.obj.creationDate, "dd / MM / yyyy")}</p>*/}

						<a href={news.absoluteUrl} title={news.title}>
							<h6 className="font-bold">{news.title}</h6>
						</a>

						{news.blurb && <p className="mb-8">{news.blurb}</p>}

						<div className="flex-grow"/>

						<div className="relative">
							<a href={news.absoluteUrl} title={news.title}>
								<img
									src={news?.cover && getImgUrl(AssetMode.Thumb, news.coverId, news.cover.filename, 547, 300)}
									alt=""
									width={547}
									height={291}
									className="w-full"
								/>
							</a>

							<a
								href={news.absoluteUrl}
								title={news.title}
								className="absolute bottom-4 left-4 button white mb-0"
							>
								Read more
							</a>
						</div>

					</div>
				</div>
			</div>
		</>
	);
}

export default memo(NewsBox);
